import * as config from 'config'
import { GoogleMapsService } from './googleMapsService'

const googleMapsApisEndpoint = config.getRequired('google-maps-api-endpoint')
const googleMapsApiKey = config.getRequired('google-maps-api-key')

const googleMapsService = new GoogleMapsService(googleMapsApisEndpoint, googleMapsApiKey)

export default googleMapsService
